/**
 * Centralized z-index scale for the Nula UI.
 *
 * Layer order (lowest to highest):
 *   content < sticky < dropdown < overlay < modal < popover < dropdownInPopover < toast < max
 *
 * Components should import from here instead of using magic numbers.
 * When a component needs to stack above another at the same layer,
 * add a specific named token here rather than inventing a new number.
 */
export const zIndex = {
  /** Default content layer (cards, badges, etc.) */
  content: 1,
  /** Sticky headers, scroll-to-top, actionbars */
  sticky: 10,
  /** Sidebar overlays */
  sidebar: 100,
  /** Dropdowns, selects, date pickers, autocomplete, mentions */
  dropdown: 200,
  /** Fixed/floating elements: affix, float buttons */
  fixed: 300,
  /** Overlay backdrops (behind modals, above fixed content) */
  overlay: 500,
  /** Modal/drawer backdrop and content */
  modal: 1000,
  /** Popovers, popconfirms, tooltips that appear over modals */
  popover: 1100,
  /** A Dropdown menu opened from inside a Popover's content — must clear the popover's own opaque panel */
  dropdownInPopover: 1150,
  /** Notifications, messages, toasts */
  toast: 1200,
  /** Emoji picker, floating panels that must be topmost */
  max: 1300,
} as const;

export type ZIndexToken = keyof typeof zIndex;
